import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IxIcon, IxMenuAboutItem } from '@siemens/ix-angular/standalone';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { AppVersion } from '../../../environments/app.version';

@Component({
  selector: 'about-info',
  imports: [IxMenuAboutItem, IxIcon, TranslateModule],
  styleUrl: './about-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ix-menu-about-item [label]="'NAVIGATION.INFO' | translate">
      <b>{{applicationName()}}</b>
      <p><i>{{versionString}}</i></p>
      <p>Copyright © 2025 Siemens Mobility GmbH</p>

      <a class="external-link-group" target="_blank" [href]="'ABOUT_AND_LEGAL.CORPORATE_INFORMATION_URL' | translate">
        <ix-icon name="chevron-right-small" /> {{'NAVIGATION.CORPORATE_INFORMATION' | translate}}
      </a>

      <a class="external-link-group" target="_blank" [href]="'ABOUT_AND_LEGAL.DATA_PRIVACY_URL' | translate">
        <ix-icon name="chevron-right-small" /> {{'NAVIGATION.PRIVACY_POLICY' | translate}}
      </a>

      <a class="external-link-group" target="_blank" [href]="'ABOUT_AND_LEGAL.TERMS_OF_USE_URL' | translate">
        <ix-icon name="chevron-right-small" /> {{'NAVIGATION.TERMS_OF_USE' | translate}}
      </a>
    </ix-menu-about-item>
  `
})
export class AboutInfoComponent {
  private translateService = inject(TranslateService);

  readonly applicationName = toSignal(this.translateService.get('APP.NAME').pipe(
    map(appName => AppVersion.flavor === "PRD" ? appName : `${appName} (${AppVersion.flavor})`)
  ), { initialValue: "APP.NAME" });

  // eslint-disable-next-line max-len
  versionString = `Version: ${AppVersion.appVersion}-${AppVersion.gitHash} (${AppVersion.flavor}) from ${new Date(AppVersion.buildTimestamp).toLocaleString()}`
}
